<template>
  <div>
    <PageTitle :route="$route">
      <template slot="action-button">
        <ActionButton
          icon="fa-plus"
          v-on:click="onClickButton"
        />
      </template>
    </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <ActivesTypeList />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import ActivesTypeList from '@/components/settings/stock-registers/activesType/ActivesTypeList'
import ActionButton from '@/components/button/ActionButton'

export default {
  name: 'ActivesType',
  components: {
    PageTitle,
    ActionButton,
    PageRowWrapper,
    ActivesTypeList
  },
  methods: {
    onClickButton (e) {
      this.$router.push({ name: 'addactivestype' })
    }
  }
}
</script>
